module.exports = __webpack_public_path__ + "img/RepGuide-Notebook-Tablet-Phone-Lukas.fc43fb73.png";